import * as React from 'react';
import { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

export const ExploreTabSvg: React.FC<Props> = ({ color = '#F5C102' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
      <path
        fill={color}
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 
           10-4.48 10-10S17.52 2 12 2zm4.93 6.36l-2.12 5.66a1 
           1 0 0 1-.58.58l-5.66 2.12a.25.25 0 0 1-.32-.32l2.12-5.66a1 
           1 0 0 1 .58-.58l5.66-2.12a.25.25 0 0 1 .32.32z"
      />
    </svg>
  );
};
